import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
//theme
import { withExtendedClass } from "../../../utils/utilities.style";

const sizing = {
  xSmall: `
    font-size: 14px;
  `,
  small: `
    font-size: 18px;
  `,
  medium: `
    font-size: 24px;
  `,
  large: `
    font-size: 32px;
  `,
  xLarge: `
    font-size: 36px;
  `,
  xxLarge: `
    font-size: 42px;
  `,
  xxxLarge: `
    font-size: 48px;
  `
};

const Icon = styled.i.attrs(({ className, name }) =>
  withExtendedClass({
    className,
    extend: `${name}`
  })
)`
  /*
  -- Size
  */
  ${props => sizing[props.size || "medium"]};
  /*
  -- Main props
  */
  color: ${props => props.color || props.theme.components.icon.color};
  font-size: ${props => props.fontSize};
  min-width: ${props => props.minWidth};
  margin-right: ${props => props.marginRight};
  margin-left: ${props => props.marginLeft};
`;

Icon.defaultProps = {
  name: "fas fa-info"
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  minWidth: PropTypes.string,
  marginRight: PropTypes.string,
  marginLeft: PropTypes.string
};

export default Icon;
